import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createMuiTheme } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import React, { Component } from 'react';
import classes from './SingleDatePicker.module.css';
import Input from 'components/UI/Input/Input';
import YearMonthPicker from 'containers/UI/DateSelection/YearMonthPicker/YearMonthPicker';
import { formatDateForDisplay, preparePostDateForSubmission } from 'shared/utility';

const rizaTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#36a1da',
      },
    },
    MuiPickersDatePickerRoot: {
      toolbar: {
        display: 'none !important',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
      iconButton: {
        padding: '12px 8px',
      },
      dayLabel: {
        width: '44px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '231px',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#36a1da',
        width: '44px',
        height: '44px',
      },
      daySelected: {
        '&:hover:not($disabled):not($error):not($focused)': {
          backgroundColor: '#36a1da',
        },
        backgroundColor: '#36a1da',
      },

      current: {
        color: '#36a1da',
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#36a1da',
      },
    },
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        borderRadius: '0px',
        marginTop: '0px',
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        maxWidth: 'none',
      },
    },
  },
});

class SingleDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yearMonthDate: '',
      showYearMonthPicker: false,
    };
  }

  componentDidMount() {
    if (this.props.initialView === 'monthYear') this.setState({ showYearMonthPicker: true });
  }

  handleDateSelection = (date) => {
    const selectedDate = date ? date.format('MM/DD/YYYY') : '';
    this.props.handleDateSelect(selectedDate);
    this.setState({ yearMonthDate: '' });
  };

  handleDateClear = () => {
    this.handleDateSelection(null);
    if (this.state.yearMonthDate) this.setState({ yearMonthDate: '' });
  };

  handleMonthYearSelection = (date) => {
    const month = date.split('/')[0] === '00' ? '01' : date.split('/')[0].length === 1 ? `0${date.split('/')[0]}` : date.split('/')[0];
    const monthYearDate = `${month}/01/${date.split('/')[2]}`;
    this.setState({ yearMonthDate: monthYearDate, showYearMonthPicker: false });
  };

  render = () => {
    const datePickerClasses = [classes.DatePickerContainer];
    if (this.props.type) datePickerClasses.push(classes[this.props.type]);
    /* Start: Date Formatting for YearMonth and Date Pickers */

    let defaultYear = null;
    let defaultMonth = null;
    let selectedYear = null;
    let selectedMonth = null;
    let datePicker = null;

    const defaultDate = this.state.yearMonthDate
      ? this.state.yearMonthDate
      : this.props.defaultYear
      ? `${this.props.defaultMonth ? this.props.defaultMonth : '01'}/00/${this.props.defaultYear}`
      : preparePostDateForSubmission(new Date());

    // const maxDate = this.props.maxDate
    //   ? `${this.props.maxDate.split('/')[2]}-${this.props.maxDate.split('/')[1]}-${this.props.maxDate.split('/')[0]}`
    //   : null;
    const minDate = this.props.minDate
      ? `${this.props.minDate.split('/')[2]}-${this.props.minDate.split('/')[1]}-${this.props.minDate.split('/')[0]}`
      : null;

    if (this.props.date && !this.state.yearMonthDate) {
      selectedMonth = parseInt(this.props.date.split('/')[0], 10);
      selectedYear = parseInt(this.props.date.split('/')[2], 10);
    } else {
      defaultMonth = this.props.defaultMonth ? this.props.defaultMonth : 1;
      defaultYear = this.props.defaultYear ? this.props.defaultYear : new Date().getFullYear();
    }

    if (!this.state.showYearMonthPicker) {
      datePicker = (
        <div>
          <div className={classes.CalendarHeader}>
            <div className={classes.InnerContainer} onClick={() => this.setState({ showYearMonthPicker: true })}>
              <FontAwesomeIcon icon="chevron-left" className={classes.BackIcon} />
              <span>Month / Year</span>
            </div>
          </div>
          <DatePicker
            variant="static"
            autoOk
            label="Date"
            emptyLabel={this.props.dateLabel}
            clearable="false"
            format="MMM d, yyyy"
            minDate={minDate || '0001-01-01'}
            initialFocusedDate={defaultDate}
            value={this.props.date && !this.state.yearMonthDate ? this.props.date : null}
            onChange={(date) => this.handleDateSelection(date)}
            className={classes.DatePickerCalendar}
          />
        </div>
      );
    } else {
      datePicker = (
        <div className={classes.YearMonthPickerContainer}>
          <YearMonthPicker
            type={this.props.type}
            defaultYear={defaultYear}
            defaultMonth={defaultMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            totalDateRangeYears={this.props.totalDateRangeYears}
            minMonth={this.props.minDate ? parseInt(this.props.minDate.split('/')[0], 10) : null}
            minYear={this.props.minDate ? parseInt(this.props.minDate.split('/')[2], 10) : null}
            maxMonth={this.props.maxDate ? parseInt(this.props.maxDate.split('/')[0], 10) : null}
            maxYear={this.props.maxDate ? parseInt(this.props.maxDate.split('/')[2], 10) : null}
            handleDateSelection={this.handleMonthYearSelection}
            close={() => this.setState({ showYearMonthPicker: false })}
          />
        </div>
      );
    }

    return (
      <ThemeProvider theme={rizaTheme}>
        <div className={datePickerClasses.join(' ')}>
          <div className={classes.PickerFields}>
            <div className={[classes.Picker, classes.DatePicker].join(' ')}>
              <Input
                elementType="input"
                inputClassName="SingleDatePicker"
                className={classes.Active}
                label="Date"
                placeholder="Date"
                fontIcon="times-circle"
                iconClicked={this.handleDateClear}
                value={this.props.date ? formatDateForDisplay(this.props.date) : ''}
                readOnly
              />
            </div>
          </div>
          <div className={classes.OptionsPickerContainer}>
            <div className={classes.CalendarContainer}>{datePicker}</div>
          </div>
        </div>
      </ThemeProvider>
    );
  };
}

export default SingleDatePicker;
